import { isEmpty } from "lodash"
import React, { MouseEventHandler, useEffect, useState } from "react"
import { Button, Col, Form, InputGroup, Modal, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { SERVICE_TYPE } from "../../constants/constants"

const SurchargeModal = ({
    loading,
    show,
    setShow,
    surchargeDetails,
    setSurchargeDetails,
    handleClose,
    handleSubmit,
    shippingServices,
    errors,
    setErrors
}: {
    loading: boolean
    show: string
    setShow: Function
    surchargeDetails: Record<string, any>
    setSurchargeDetails: Function
    handleClose: Function
    handleSubmit: Function
    shippingServices: Record<string, any>[]
    errors: Record<string, any>
    setErrors: Function
}) => {
    const { t } = useTranslation()
    const [disabled, setDisabled] = useState(false)

    useEffect(() => {
        if (!isEmpty(errors)) {
            setErrors({})
        }
    }, [])

    useEffect(() => {
        if (
            !surchargeDetails?.name ||
            surchargeDetails?.name === "" ||
            !surchargeDetails?.default_value ||
            surchargeDetails?.default_value === 0 ||
            !surchargeDetails?.shipping_service_id ||
            surchargeDetails?.shipping_service_id === 0 ||
            !surchargeDetails?.type ||
            surchargeDetails?.type === "" ||
            (errors?.default_value && errors?.default_value !== "") ||
            (errors?.name && errors?.name !== "") ||
            (errors?.shipping_service_id && errors?.shipping_service_id !== "") ||
            (errors?.min_value && errors?.min_value !== "")
        ) {
            setDisabled(true)
        } else {
            setDisabled(false)
        }
    }, [JSON.stringify(errors), JSON.stringify(surchargeDetails)])

    return (
        <Modal
            size={"lg"}
            show={show === "editOrCreateModal"}
            onHide={() => {
                setShow(false)
                setSurchargeDetails(null)
            }}
            backdrop="static"
            keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {surchargeDetails?.id ? (
                        <>
                            {" "}
                            {t("Updating surcharge of id #")}&nbsp;
                            <span className="text-primary">{surchargeDetails?.id}</span>{" "}
                        </>
                    ) : (
                        <> {t("Create new surcharge")} </>
                    )}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="surcharge-modal">
                <Row className="d-flex justify-content-around">
                    <Col lg={12}>
                        <Row className={"container"}>
                            <Col lg={12} className="mb-3">
                                <Form.Group>
                                    <Form.Label htmlFor="name">{t("Surcharge Name")}</Form.Label>
                                    <Form.Control
                                        id="name"
                                        autoComplete="off"
                                        type="text"
                                        name={"name"}
                                        value={surchargeDetails?.name || ""}
                                        onChange={(e: any) => {
                                            if (e.target.value !== "") {
                                                setErrors({ ...errors, name: "" })
                                            } else {
                                                setErrors({ ...errors, name: "Surcharge name is required" })
                                            }
                                            setSurchargeDetails({ ...surchargeDetails, name: e.target.value })
                                        }}
                                        placeholder="Surcharge Name"
                                        isInvalid={errors?.name && errors?.name !== ""}
                                    />
                                    {errors?.name && errors?.name !== "" && (
                                        <Form.Control.Feedback type="invalid">
                                            {t(`${errors?.name}`)}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col lg={12} className="mb-3">
                                <Form.Group>
                                    <Form.Label htmlFor="shippingServiceId">
                                        {t("Shipping company and Service")}
                                    </Form.Label>
                                    <Form.Select
                                        id="shippingServiceId"
                                        autoComplete="off"
                                        name={"shipping_service_id"}
                                        value={surchargeDetails?.shipping_service_id || ""}
                                        disabled={!!surchargeDetails?.id}
                                        onChange={(e: any) => {
                                            if (e.target.value !== "") {
                                                setErrors({ ...errors, shipping_service_id: "" })
                                            } else {
                                                setErrors({
                                                    ...errors,
                                                    shipping_service_id:
                                                        "Surcharge shipping service is required"
                                                })
                                            }
                                            setSurchargeDetails({
                                                ...surchargeDetails,
                                                shipping_service_id: e.target.value
                                            })
                                        }}
                                        placeholder="Select shipping service"
                                        isInvalid={
                                            errors?.shipping_service_id && errors?.shipping_service_id !== ""
                                        }>
                                        <option placeholder="Select a shipping service">
                                            Select a shipping service
                                        </option>
                                        {shippingServices?.map((ss) => (
                                            <option
                                                className="text-capitalize"
                                                key={`${ss?.id}-${ss?.shipping_service}`}
                                                value={ss.id}>
                                                {ss?.shipping_service?.replaceAll("_", " ")?.toLowerCase()}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    {errors?.shipping_service_id && errors?.shipping_service_id !== "" && (
                                        <Form.Control.Feedback type="invalid">
                                            {t(`${errors?.shipping_service_id}`)}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col lg={6} className="mb-2">
                                <Form.Group>
                                    <Form.Label htmlFor="defaultValue">{t("Default Value")}</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            id="defaultValue"
                                            type="number"
                                            autoComplete="off"
                                            name={"default_value"}
                                            value={surchargeDetails?.default_value || 0}
                                            onChange={(e: any) => {
                                                if (parseFloat(e.target.value) > 0) {
                                                    setErrors({ ...errors, default_value: "" })
                                                } else {
                                                    setErrors({
                                                        ...errors,
                                                        default_value:
                                                            "Deafult value is required, and cannot be 0 or less."
                                                    })
                                                }
                                                setSurchargeDetails({
                                                    ...surchargeDetails,
                                                    default_value: parseFloat(e.target.value),
                                                    type: surchargeDetails?.type
                                                        ? surchargeDetails.type
                                                        : SERVICE_TYPE["1"],
                                                    update_rates:
                                                        surchargeDetails?.update_rates === 0 ||
                                                        surchargeDetails?.update_rates === 1
                                                            ? surchargeDetails?.update_rates
                                                            : 1
                                                })
                                            }}
                                            placeholder="Default Value"
                                            isInvalid={errors?.default_value && errors?.default_value !== ""}
                                        />
                                        {errors?.default_value && errors?.default_value !== "" && (
                                            <Form.Control.Feedback type="invalid">
                                                {t(`${errors?.default_value}`)}
                                            </Form.Control.Feedback>
                                        )}
                                        {/* <InputGroup.Text
                                            className="tr-pointer"
                                            onClick={() => setSurchargeDetails({
                                                ...surchargeDetails,
                                                type: surchargeDetails.type === SERVICE_TYPE["0"] ?
                                                    SERVICE_TYPE["1"]
                                                    :
                                                    SERVICE_TYPE["0"]
                                            })}
                                        >
                                            { surchargeDetails?.type === SERVICE_TYPE["0"] ? "$" : "%" }
                                        </InputGroup.Text> */}
                                        <Row>
                                            <Col lg={6}>
                                                <Form.Check
                                                    type="radio"
                                                    name="type"
                                                    label={t("$")}
                                                    onChange={() =>
                                                        setSurchargeDetails({
                                                            ...surchargeDetails,
                                                            type: SERVICE_TYPE["0"]
                                                        })
                                                    }
                                                    required={true}
                                                    checked={surchargeDetails?.type === SERVICE_TYPE["0"]}
                                                />
                                            </Col>
                                            <Col lg={6}>
                                                <Form.Check
                                                    type="radio"
                                                    name="type"
                                                    label={t("%")}
                                                    onChange={() =>
                                                        setSurchargeDetails({
                                                            ...surchargeDetails,
                                                            type: SERVICE_TYPE["1"]
                                                        })
                                                    }
                                                    required={true}
                                                    checked={surchargeDetails?.type === SERVICE_TYPE["1"]}
                                                />
                                            </Col>
                                        </Row>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            {/* <Col lg={6}>
                                <Form.Group>
                                    <Form.Label htmlFor="surchargeType">{t("Default Value")}</Form.Label>
                                    <Row id="surchargeType">
                                        <Col lg={6}>
                                            <Form.Check
                                                type="radio"
                                                name="type"
                                                label={t("Flat")}
                                                onChange={(e: any) => {
                                                    setSurchargeDetails({ ...surchargeDetails, type: SERVICE_TYPE["0"] })
                                                }}
                                                required={true}
                                                checked={
                                                    surchargeDetails?.type === SERVICE_TYPE["0"]
                                                }
                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Check
                                                type="radio"
                                                name="type"
                                                label={t("Percentage")}
                                                onChange={(e: any) => {
                                                    setSurchargeDetails({ ...surchargeDetails, type: SERVICE_TYPE["1"] })
                                                }}
                                                required={true}
                                                checked={
                                                    surchargeDetails?.type === SERVICE_TYPE["1"]
                                                }
                                            />
                                        </Col>
                                    </Row>
                                </Form.Group>
                            </Col> */}
                            {/* <Col lg={12}>
                                <Form.Group className="mt-4">
                                    <Form.Check
                                        type="checkbox"
                                        name="is_main"
                                        label={t("Main surcharge")}
                                        onChange={(e: any) =>
                                            setSurchargeDetails({ ...surchargeDetails, [e.target.name]: e.target.checked ? 1 : 0 })
                                        }
                                        required={true}
                                        checked={surchargeDetails?.is_main}
                                    />
                                </Form.Group>
                            </Col> */}

                            <Row>
                                <Col lg={6} xs={12}>
                                    <Row>
                                        <Col lg={6}>
                                            <Form.Check
                                                type="radio"
                                                name="update_rates"
                                                label={t("Apply to existing")}
                                                onChange={() =>
                                                    setSurchargeDetails({
                                                        ...surchargeDetails,
                                                        update_rates: 1
                                                    })
                                                }
                                                required={true}
                                                checked={surchargeDetails?.update_rates === 1}
                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Check
                                                type="radio"
                                                name="update_rates"
                                                label={t("Do not apply")}
                                                onChange={() =>
                                                    setSurchargeDetails({
                                                        ...surchargeDetails,
                                                        update_rates: 0
                                                    })
                                                }
                                                required={true}
                                                checked={surchargeDetails?.update_rates === 0}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Row>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose as MouseEventHandler<HTMLButtonElement>}>
                    {t("Close")}
                </Button>

                <Button
                    onClick={() => {
                        handleSubmit(surchargeDetails)
                        handleClose()
                    }}
                    disabled={disabled}
                    className="btn primary-bg"
                    type="submit">
                    {loading ? (
                        <div className="spinner-border text-light" role="submit"></div>
                    ) : surchargeDetails?.id ? (
                        t("Update")
                    ) : (
                        t("Save")
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default SurchargeModal
